var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('common-dialog',{ref:"dialog",attrs:{"width":"1000px","title":"加工单列表","id-key":"UserId"},on:{"close-saved":function($event){return _vm.$emit('close-saved')}}},[_c('list',{ref:"list"}),_c('div',{attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.saved}},[_vm._v("保存")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }